import { NgModule } from '@angular/core';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './content-layout/content-layout.component';
import { InfoCardLayoutComponent } from './info-card-layout/info-card-layout.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ToolbarLayoutComponent } from './toolbar-layout/toolbar-layout.component';
import { MatMenuModule } from '@angular/material/menu';
import { DrawerRailModule } from 'angular-material-rail-drawer';
import { MatBadgeModule } from '@angular/material/badge';
import { PrimaryBgLayoutComponent } from './primary-bg-layout/primary-bg-layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    AuthLayoutComponent,
    ContentLayoutComponent,
    InfoCardLayoutComponent,
    SidenavComponent,
    ToolbarLayoutComponent,
    PrimaryBgLayoutComponent,
  ],
  imports: [
    SharedModule,
    RouterModule,

    MatCardModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    FlexModule,
    MatMenuModule,
    DrawerRailModule,
    MatBadgeModule,
    TranslateModule,
    SharedModule,
    MatSlideToggleModule,
  ],
  exports: [InfoCardLayoutComponent],
})
export class LayoutModule {}
